var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatureImage5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 52,
    viewBox: "0 0 47 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1469_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5049 32.0594C19.5002 25.3127 24.7065 20.1297 31.4208 20.19C38.0422 20.2549 43.1371 25.373 43.1835 32.0177C43.2299 38.834 38.1814 44.0356 31.4625 44.0913C24.5719 44.1516 19.5095 39.0614 19.5049 32.0594ZM29.2028 36.4258C29.3652 36.3562 29.6111 36.3052 29.7828 36.166C32.3256 34.0315 34.8684 31.8878 37.388 29.7255C37.8473 29.331 37.9216 28.7557 37.5272 28.2685C37.0307 27.6606 36.4228 27.7905 35.8939 28.236C34.3533 29.5306 32.72 30.737 31.3419 32.1847C29.8246 33.7809 28.7016 33.9201 27.4766 31.9342C27.0173 31.1917 26.2748 30.1291 25.2726 30.9644C24.2285 31.8367 25.3283 32.6116 25.8619 33.2937C26.5301 34.1429 27.2678 34.9363 27.9871 35.7437C28.2979 36.0964 28.6228 36.4351 29.2028 36.4258Z",
    fill: "#009C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2677 20.222C15.0732 27.5395 15.5048 37.2466 23.0125 43.8264C21.8478 44.3368 20.711 44.1187 19.6299 44.128C16.391 44.1558 13.1476 44.179 9.90877 44.1001C6.34979 44.0166 4.24317 41.9935 4.1782 38.518C4.09932 34.1981 4.11324 29.8781 4.19676 25.5581C4.25245 22.5977 6.11314 20.3937 8.97611 20.273C13.5698 20.0828 18.1821 20.222 23.2677 20.222Z",
    fill: "#009C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1473 0.631276C21.806 0.584875 25.7362 4.41763 25.8058 9.08097C25.8847 13.9856 21.9313 18.0504 17.1195 18.0132C12.4747 17.9761 8.59093 14.0691 8.57237 9.41042C8.54917 4.57075 12.3494 0.677678 17.1473 0.631276Z",
    fill: "#009C70"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1469_6",
    x: 0.674181,
    y: 0.630859,
    width: 45.9612,
    height: 50.4387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.4518
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.7259
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.611765 0 0 0 0 0.439216 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1469_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1469_6",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureImage5);
export default __webpack_public_path__ + "static/media/FeatureImage5.49dadb3e2ef7435c5df57c3c26331d6d.svg";
export { ForwardRef as ReactComponent };